var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"progress-tab-list"},_vm._l((_vm.tabs),function(item){return _c('li',{key:item.value,staticClass:"progress-tab"},[_c('span',{class:{ on: item.value === _vm.currentTab }},[_vm._v(_vm._s(item.label))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }